var React = require('react');

function IcPencilInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.82847 14.3136L17.3138 5.82828L19.123 7.63751L10.6377 16.1228L8.82847 14.3136ZM16.6066 3.70696C16.9972 3.31643 17.6303 3.31643 18.0209 3.70696L21.2443 6.9304C21.6348 7.32093 21.6348 7.95409 21.2443 8.34462L11.3448 18.2441C10.9543 18.6346 10.3211 18.6346 9.9306 18.2441L6.70715 15.0207C6.31663 14.6301 6.31663 13.997 6.70715 13.6065L16.6066 3.70696ZM5.19497 16.1948L8.80502 19.8048C9.246 20.2458 8.93368 20.9998 8.31005 20.9998H4.7C4.3134 20.9998 4 20.6864 4 20.2998V16.6898C4 16.0661 4.754 15.7538 5.19497 16.1948Z","fill":"#3377C6"}));
}

IcPencilInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcPencilInline;

IcPencilInline.default = IcPencilInline;
